import React from 'react';

import './AccountSettings.pcss';
import { AccountLayoutCard } from './account-layout-card';
import { UserProfile } from '../../../api/user-profile/userProfileTypes';
import { RbacRoleKeys } from '../../../constants/rbac';
import { LoginAsUserContainer } from './login-as-user';

interface Props {
  user: UserProfile,
}

export const AccountSettings = ({ user }: Props) => (
  <div className="AccountSettings">
    {
      user!.rbac_role_id === RbacRoleKeys.SystemAdmin
      && (
        <AccountLayoutCard
          className="AccountSettings-card"
          title={
            <AccountLayoutCard.Title title="Login as user" titleId="login-as-user" />
          }
        >
          <LoginAsUserContainer />
        </AccountLayoutCard>
      )
    }
  </div>
);

export default AccountSettings;
